import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  state: {
    info: {
      publicShopKey: '',
      categoryId: '',
      message: '',
      user: [],
      velaeasyDomain: '',
      hostType: '',
      enable: false
    }
  },
  mutations,
  actions,
  getters
}
